import { MultiLangString } from '@starjack/utils';

export type Faq = {
    id: string;
    liftOperatorId: string;
    titleMulti: MultiLangString;
    textMulti: MultiLangString;
    priority: number;
    hideInIntegration: boolean;
    groupId?: string | null;
    page?: string;
};

export type CreateFaq = Omit<Faq, 'id'>;

export const createEmptyFaq = (liftOperatorId?: string): CreateFaq => ({
    liftOperatorId: liftOperatorId || '',
    titleMulti: { de: '', en: '' },
    textMulti: { de: '', en: '' },
    priority: 0,
    hideInIntegration: false,
    groupId: null,
    page: '',
});

export const isOfTypeFaq = (faq: Faq | CreateFaq): faq is Faq => {
    return !!faq?.['id'];
};

export type FaqGroup = {
    id: string;
    name: MultiLangString;
    priority: number;
};

export type CreateFaqGroup = Omit<FaqGroup, 'id'>;

export const isOfTypeFaqGroup = (
    group: FaqGroup | CreateFaqGroup
): group is FaqGroup => {
    return !!group?.['id'];
};

export const createEmptyFaqGroup = (): CreateFaqGroup => ({
    name: {
        de: '',
        en: '',
    },
    priority: 0,
});

export type FaqGroupStructure = (FaqGroup & {
    faqs: Faq[];
})[];
